import React from 'react';

export default function TicketsHeader() {
  return (
    <div className="tickets__header">
      <span className="tickets-header__heading">İade Kodu</span>
      <span className="tickets-header__heading">Ad Soyad</span>
      <span className="tickets-header__heading">Neden</span>
      <span className="tickets-header__heading">Durum</span>
    </div>
  );
}
